<template>
    <div class="blocker-abstract">

        <v-sheet
            class="sheet" 
            color="darkerbase" 
            elevation="1">

            <LayoutColumn>
                <!-- TODO: teaser outside of sheet -->
                <div class="teaser">
                    <slot name="teaser"></slot>
                </div>

                <div class="message">
                    <slot name="message"></slot>
                </div>

                <div class="actions">
                    <slot name="actions"></slot>
                </div>
            </LayoutColumn>

        </v-sheet>

    </div>
</template>

<script>
import { LayoutColumn } from '@generio-ai/library-legacy/components/layouts'

export default {
    name: 'BlockerAbstract',
    components: {
        LayoutColumn
    }
}
</script>

<style>
.blocker-abstract {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.blocker-abstract .sheet {
    padding: 50px;
    border-radius: 8px;
}

.blocker-abstract .message {
    font-size: 1.3rem;
}

@media (max-width: 600px) {
    .blocker-abstract .sheet {
        border-radius: 0px;
    }
}
</style>